module.exports = __webpack_public_path__ + "img/login.8ec7c8a3.jpg";